import { Component, Shark } from "shark-mvc";

import templateContent from "./user-metadata-box.html";

class UserMetadataBoxComponent extends Component {
	constructor () {
		super("userMetadataBoxComponent");
		this.addTemplate("", templateContent);
	}

	init () {
	}
}

const userMetadataBoxComponent = new UserMetadataBoxComponent();

Shark.registerComponent(userMetadataBoxComponent);

export default userMetadataBoxComponent;
